<header [className]="(isMobile == true)?'mobile_header':'web_class'" [ngStyle]="{position:showSmartBanner == true?'relative':'fixed'}">   
    <div class="container-fluid" [ngClass]="{'isWelcome':!showHeader}" *ngIf="isMobile == false">
        <div class="row">
            <div class="col s12 m5 l5 xl5" [ngClass]="{'isWelcomeCol':!showHeader}">
                <div class="logo">
                    <a href="{{siteURL}}">
                        <img *ngIf="darkMode" src="assets/images/logo.png" alt="">
                        <img *ngIf="!darkMode" src="assets/images/logo.png" alt="">
                    </a>
                </div>
                <div class="nav-wrapper" *ngIf="showHeader">
                    
                    <ul class="leftNav ">
                        <li>
                            <a [ngClass]="{active:pageName.indexOf('lobby') > -1}" routerLink="/lobby">Lobby</a>
                        </li>
                        <li class="liDropDown myteamDp">
                            <a [ngClass]="{active:pageName.indexOf('myteams') > -1}" routerLink="/myteams">My
                                Teams</a>
                            <!-- <a class="active" (mouseover)="myTeamFilter('drafting',0)" href="{{siteURL}}/scores">My
                                Teams</a> -->
                            <!-- <div class="myteamDpMain">
                                <mat-radio-group>
                                    <mat-radio-button [checked]="(myTeamChecked == 'drafting')?true:false"
                                        value="Drafting" (click)="myTeamFilter('drafting',0)">Drafting
                                    </mat-radio-button>
                                    <mat-radio-button [checked]="(myTeamChecked == 'progress')?true:false" value="Live"
                                        (click)="myTeamFilter('progress',0)">Live</mat-radio-button>
                                    <mat-radio-button [checked]="(myTeamChecked == 'upcoming')?true:false"
                                        value="Upcoming" (click)="myTeamFilter('upcoming',0)">Upcoming
                                    </mat-radio-button>
                                    <mat-radio-button [checked]="(myTeamChecked == 'completed')?true:false"
                                        value="Completed" (click)="myTeamFilter('completed',0)">Completed
                                    </mat-radio-button>
                                </mat-radio-group>
                                <perfect-scrollbar class="mainTeamScroll" [config]="config"
                                    (psScrollY)="onScrollEvent($event)">
                                    <div class="myteamDpIn" *ngFor="let my_team of my_team_data">
                                        <ng-container *ngIf="my_team.league_code; else tournament">
                                            <a
                                                routerLink="/resultboard/draft/players/{{my_team.game_abbr}}/{{my_team.league_code}}">
                                                <span class="oneimg">
                                                    <img *ngIf="my_team.commissioner_id == my_team.user_id"
                                                        src="{{assetURL}}/assets/default/images/football-shirt.svg"
                                                        alt="">
                                                </span>
                                                <span class="oneimg">
                                                    <img src="{{assetURL}}/assets/default/images/{{my_team.game_abbr}}.svg"
                                                        alt="">
                                                </span>
                                                <span class="three">
                                                    <a href="javascript:void(0)"
                                                        routerLink="/resultboard/draft/players/{{my_team.game_abbr}}/{{my_team.league_code}}">{{my_team.team_name}}</a>
                                                    <a href="javascript:void(0)"
                                                        routerLink="/resultboard/draft/players/{{my_team.game_abbr}}/{{my_team.league_code}}">{{my_team.league_name}}</a>
                                                </span>
                                                <span class="four">{{draftStatus}}</span>
                                                <ng-container *ngIf="draftStatus != 'drafting'; else draftnoscore"><span
                                                        class="five">{{my_team.team_rank}} of
                                                        {{my_team.entrants}}</span></ng-container>
                                                <ng-template #draftnoscore><span class="five"> - </span></ng-template>
                                            </a>
                                        </ng-container>

                                        <ng-template #tournament>
                                            <a
                                                routerLink="/resultboard/draft/players/{{my_team.game_abbr}}/{{my_team.tournament_code}}/{{tournamentURL}}">
                                                <span class="oneimg">
                                                    <img *ngIf="my_team.commissioner_id == my_team.user_id"
                                                        src="{{assetURL}}/assets/default/images/football-shirt.svg"
                                                        alt="">
                                                </span>
                                                <span class="oneimg">
                                                    <img src="{{assetURL}}/assets/default/images/{{my_team.game_abbr}}.svg"
                                                        alt="">
                                                </span>
                                                <span class="three">
                                                    <a href="javascript:void(0)"
                                                        routerLink="/resultboard/draft/players/{{my_team.game_abbr}}/{{my_team.tournament_code}}/{{tournamentURL}}">{{my_team.team_name}}</a>
                                                    <a href="javascript:void(0)"
                                                        routerLink="/resultboard/draft/players/{{my_team.game_abbr}}/{{my_team.tournament_code}}/{{tournamentURL}}">{{my_team.league_name}}</a>
                                                </span>
                                                <span class="four">{{draftStatus}}</span>
                                                <ng-container *ngIf="draftStatus != 'drafting'; else draftnoscore"><span
                                                        class="five">{{my_team.team_rank}} of
                                                        {{my_team.entrants}}</span></ng-container>
                                                <ng-template #draftnoscore><span class="five"> - </span></ng-template>
                                            </a>
                                        </ng-template>

                                    </div>
                                </perfect-scrollbar>

                                <button mat-raised-button (click)="myTeamPage()" class="custom-btn btn">Full My Teams
                                    Page</button>
                            </div> -->
                        </li>
                        <li class="">
                            <a [ngClass]="{active:pageName.indexOf('rankings') > -1}"
                                routerLink="/rankings">Rankings</a>
                        </li>
                        <li>
                            <a [ngClass]="{active:(pageName.indexOf('props') > -1 || pageName.indexOf('props-myteams') > -1)}"
                                routerLink="/props">Pick'em <span class="newBadge" *ngIf="this.props_launch_flag!=''">New</span></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col s12 m7 l7 xl7" *ngIf="showHeader">
                <div class="headerRight text-right">
                        <div class="dark-theme-toggle">
                            <label for="checkbox" class="label">
                              <input type="checkbox"  style="cursor: pointer;" class="checkbox" (click)="toggleDarkTheme()" id="checkbox">
                              <i class="fas fa-moon" *ngIf="this.darkMode"></i>
                              <i class='far fa-moon'  *ngIf="!this.darkMode"></i>
                            </label>
                        </div>
                    <div class="earnCash1 dIb">
                        <!-- <a href="{{siteURL+'/user/refer-friend'}}"> -->
                        <a routerLink ="/user/refer-friend" [ngClass]="{active:(pageName.indexOf('refer-friend') > -1)}">
                            <i _ngcontent-c3="" class="fas fa-heart"></i> &nbsp;Refer a Friend
                        </a>
                    </div>
                    <div class="myAccontDd">
                        <button id="user-menu-btn" #toggleButton (click)="toggleMenu()">
                            <span class="userName" *ngIf="drafters_id">{{drafters_id}}</span>
                            <span class="userImg dynamicBg"
                                [ngStyle]="{'background-image': 'url(' + ((userInfo && userInfo.picture)?(userInfo?.picture):'') + ')'}">
                                <span id="msgNumber" *ngIf="(notifiCounter + msgCounter) > 0">{{notifiCounter + msgCounter}}</span>
                            </span>
                            <i class="zmdi zmdi-chevron-down"></i>
                        </button>
                        <div class="myAccontDdin" *ngIf="isMenuVisible" #menu>
                            <!--  <button mat-menu-item disabled class="myWal accDdList">
                                <span>Cash: $ {{ userInfo?.dollar_balance | number:'0.1-2' }}</span>
                                <span class="brno">In Play: $ {{ userInfo?.inplay_dollar_balance | number:'0.1-2' }}</span>

                            </button> -->
                            <a mat-menu-item class="accDdList" href="{{siteURL+'/'+user_name+'/profile'}}"><i
                                    class="fas fa-user"></i>My Profile</a>
                            <a mat-menu-item class="accDdList" href="{{siteURL+'/setting'}}"><i
                                    class="fas fa-user-edit"></i>My Account</a>
                            <a mat-menu-item class="accDdList" href="javascript:;"
                                [routerLink]="[ '/ownership', 'nfl' ]"><i
                                    class="fas fa-user-circle"></i>Player Exposures</a>
                            <a mat-menu-item class="accDdList" [matMenuTriggerFor]="menudropdown3">
                                <i class="fas fa-bell"></i>Notifications
                                <span *ngIf="notifiCounter" class="notCount">{{notifiCounter}}</span>
                            </a>
                            <mat-menu panelClass="menu_dropdown " #menudropdown3="matMenu" class="header-user-menu">
                                <div class="notifiDpMain notifiDp3">
                                    <div class="messHeader">Notifications</div>
                                    <perfect-scrollbar #notiScroll style="max-width: 100%; max-height:280px;"
                                        [config]="{suppressScrollX:'false'}" (psYReachEnd)="getNotification()">
                                        <ul>
                                            <ng-container
                                                *ngIf="(notificationData && notificationData.length > 0);else no_notificationData">

                                                <li *ngFor="let notiItem of notificationData">
                                                    <a href="{{notiItem.link}}">
                                                        <div class="notifiPic"
                                                            [ngStyle]="{'background-image': 'url(' + notiItem.user_picture +')'}">
                                                        </div>
                                                        <h4>{{ notiItem.message }}</h4>
                                                        <h5 class="">{{ notiItem.created * 1000 | date: 'MMM d, h:mm a' }}</h5>
                                                    </a>
                                                </li>
                                            </ng-container>
                                            <ng-template #no_notificationData>
                                                <li class="noMess">

                                                    <a href="javascript:;">
                                                        <h3>No Notification</h3>
                                                    </a>
                                                </li>
                                            </ng-template>
                                        </ul>

                                    </perfect-scrollbar>
                                    <div class="notifiDpBtm">
                                        <a href="{{siteURL}}/user/notifications">
                                            See all notifications
                                        </a>
                                    </div>
                                </div>
                            </mat-menu>
                            <a mat-menu-item class="accDdList" [matMenuTriggerFor]="menudropdown2">
                                <i class="fa fa-envelope"></i>Messages
                                <span *ngIf="msgCounter" class="notCount">{{msgCounter}}</span>
                            </a>
                            <mat-menu panelClass="menu_dropdown " #menudropdown2="matMenu" class="header-user-menu">
                                <div class="notifiDpMain notifiDp3 notifiDp3Mess">
                                    <div class="messHeader">Messages</div>
                                    <perfect-scrollbar #msgScroll style="max-width: 100%; max-height:280px;"
                                        [config]="{suppressScrollX:'false'}" (psYReachEnd)="getMessages()">
                                        <ul>
                                            <ng-container
                                                *ngIf="(messages && messages.length > 0);else no_msg_request">
                                                <li *ngFor="let item of messages">
                                                    <a href="javascript:;" routerLink="/messages/{{item?.drafters_id}}">
                                                        <div class="notifiPic"
                                                            [ngStyle]="{'background-image': 'url(' + _appService.getPicture(item.picture,'users',item.friend_id) + ')'}">
                                                        </div>
                                                        <h4 class="">
                                                            <span>{{item.drafters_id}} </span>
                                                            <p [innerHTML]="unescapeMessage(item.chat_message) | emojis"></p>
                                                        </h4>
                                                        <h5 class="{{item.created}}">{{item.created | date:'MMM d, y h:mm a'}}</h5>
                                                    </a>
                                                </li>
                                            </ng-container>
                                            <ng-template #no_msg_request>
                                                <li class="noMess">

                                                    <a href="javascript:;">
                                                        <h3>No messages</h3>
                                                    </a>
                                                </li>
                                            </ng-template>
                                        </ul>
                                    </perfect-scrollbar>
                                    <div class="notifiDpBtm">
                                        <a routerLink="/messages">
                                            All Messages
                                        </a>
                                    </div>
                                </div>
                            </mat-menu>
                            <!-- <a mat-menu-item class="accDdList" href="{{siteURL+'/user/refer-friend'}}"><i -->
                            <a mat-menu-item class="accDdList" routerLink ="/user/refer-friend" [ngClass]="{active:(pageName.indexOf('refer-friend') > -1)}"><i
                                    class="fas fa-heart"></i>Refer a Friend</a>
                            <a mat-menu-item class="accDdList" [matMenuTriggerFor]="menudropdown1">
                                <i class="fas fa-users"></i>Pending Requests
                                <span *ngIf="pRCounter" class="notCount">{{pRCounter}}</span>
                            </a>
                            <mat-menu panelClass="menu_dropdown " #menudropdown1="matMenu" class="header-user-menu">
                                <div class="notifiDpMain notifiDp3 notifiDp3Req">
                                    <div class="messHeader">Pending Requests</div>
                                    <perfect-scrollbar #friendRequestScroll
                                        style="max-width: 100%; max-height:280px;"
                                        [config]="{suppressScrollX:'false'}">
                                        <ul>
                                            <ng-container
                                                *ngIf="(friend_request && friend_request.length > 0);else no_request">
                                                <li *ngFor="let item of friend_request;let i = index" [ngClass]="{'invitation-request':item.type == 'invitation'}">
                                                    <a href="javascript:;">
                                                        <div class="notifiPic"
                                                            [ngStyle]="{'background-image': 'url(' + item?.picture + ')'}">
                                                        </div>

                                                        <ng-container *ngIf="item.type == 'friends'">
                                                            <h4 class=""><span>{{item.drafters_id}} </span></h4>
                                                            <div class="pT5 requestBtn">
                                                                <button mat-raised-button color="primary"
                                                                    class="acceptBtn "
                                                                    (click)="acceptFriendRequest(item.friend_id,i,item)"><i
                                                                        class="zmdi zmdi-check"></i></button>

                                                                <button mat-raised-button color="primary"
                                                                    class="rejectBTn"
                                                                    (click)="rejectFriendRequest(item.friend_id,i)"><i
                                                                        class="zmdi zmdi-close"></i></button>

                                                            </div>
                                                        </ng-container>
                                                        <ng-container *ngIf="item.type == 'invitation'">
                                                            <h4>
                                                                <a href="javascript:;"
                                                                    (click)="acceptInvitation(item)"> <span>{{item.drafters_id}} </span> {{' has invite you to join a league: ' + item.league_name}}
                                                                </a>
                                                            </h4>
                                                        </ng-container>
                                                    </a>
                                                </li>
                                            </ng-container>
                                            <ng-template #no_request>
                                                <li class="noMess">
                                                    <a href="javascript:;">
                                                        <h3>No New Request</h3>
                                                    </a>
                                                </li>
                                            </ng-template>
                                        </ul>
                                    </perfect-scrollbar>
                                </div>
                            </mat-menu>
                            <a mat-menu-item class="accDdList" href="{{siteURL+'/'+user_name+'/friends'}}"><i
                                    class="fas fa-user-plus"></i>Find Friends</a>
                            <a mat-menu-item class="accDdList" href="{{siteURL+'/rules'}}"><i
                                    class="fas fa-gavel"></i>Rules and Scoring</a>
                            <a mat-menu-item class="accDdList" href="{{siteURL+'/pages/privacypolicy'}}"><i
                                    class="fas fa-user-shield"></i>Privacy Policy</a>
                            <a mat-menu-item class="accDdList" href="{{siteURL+'/pages/termsofuse'}}"><i
                                    class="fas fa-info-circle"></i>Terms & Conditions</a>
                            <!--  <button mat-menu-item class="accDdList"><i class="fas fa-user"></i>My Profile</button> -->
                            <a mat-menu-item class="accDdList" href="javascript:void(0)" (click)="openFAQ()">
                                <i class="zmdi zmdi-help"></i>Help
                            </a>
                            <a mat-menu-item class="accDdList" routerLink="/responsible"><i
                                    class="fas fa-hands-helping"></i>Responsible Gaming</a>
                            <a mat-menu-item class="accDdList" href="javascript:void(0)" (click)="onLogout()">
                                <i class="fas fa-info-circle"></i>Log Out
                            </a>
                        </div>
                    </div>
                    <div class="topNotification">
                        <ul>
                            <li><span class="text-right" (click)="openDialog(0)" style="cursor: pointer;">
                                    ${{ userInfo?.dollar_balance | number: '1.2-2' | Price}}</span></li>
                            <!--  <li><span class="text-left">Balance: </span><span class="text-right">
                                    ${{ userInfo?.dollar_balance | number:'0.1-2' }}</span></li>
                            <li><span class="text-left">In Play: </span><span
                                    class="text-right">${{ userInfo?.inplay_dollar_balance | number:'0.1-2' }}</span>
                            </li>
                            <li><span class="text-left">Currently Winning: </span><span
                                    class="text-right">${{ winAmt | number:'0.2-2' }}</span></li> -->
                        </ul>
                    </div>
                    <!-- <div class="topNotification dIb">
                        <ul>
                            <li class="">
                                <a mat-button [matMenuTriggerFor]="menudropdown1">
                                    <i class="zmdi zmdi-accounts-alt zmdi-hc-fw"></i>
                                    <span *ngIf="pRCounter" class="notCount">{{pRCounter}}</span>
                                </a>
                                <mat-menu panelClass="menu_dropdown " #menudropdown1="matMenu">
                                    <div class="notifiDpMain notifiDp3">
                                        <div class="messHeader">
                                            Pending Requests
                                        </div>
                                        <perfect-scrollbar #friendRequestScroll style="max-width: 100%; max-height:280px;" [config]="{suppressScrollX:'false'}">
                                            <ul>
                                                <ng-container *ngIf="(friend_request && friend_request.length > 0);else no_request">
                                                    <li *ngFor="let item of friend_request;let i = index">
                                                        <a href="javascript:;">
                                                            <div class="notifiPic" [ngStyle]="{'background-image': 'url(' + awsUploadUrl+'/users/'+item?.friend_id+'/profile/image_50x50/'+item?.picture + ')'}" ></div>
                                                            
                                                            <ng-container *ngIf="item.type == 'friends'">
                                                                <h4 class="messHed">{{item.drafters_id}} </h4>
                                                                <div class="pT5 requestBtn">
                                                                    <button mat-raised-button color="primary" class="acceptBtn " (click)="acceptFriendRequest(item.friend_id,i,item)">Accept</button>
                                                                        
                                                                    <button mat-raised-button color="primary" class="rejectBTn" (click)="rejectFriendRequest(item.friend_id,i)">Reject</button> 

                                                                </div>
                                                            </ng-container>   
                                                            <ng-container *ngIf="item.type == 'invitation'">
                                                                <h4 class="messHed">
                                                                    <a href="javascript:;" (click)="acceptInvitation(item)">{{item.drafters_id+' invited you to join the '+item.league_name}} </a>
                                                                </h4>
                                                            </ng-container>   
                                                        </a>
                                                    </li>
                                                </ng-container>
                                                <ng-template #no_request>
                                                   <li class="noMess">

                                                                <a href="javascript:;">
                                                                    <h3>No New Request</h3>
                                                                </a>
                                                            </li>
                                                </ng-template>
                                            </ul>
                                        </perfect-scrollbar>
                                    </div>
                                </mat-menu>
                            </li>

                            <li class="">
                                <a mat-button [matMenuTriggerFor]="menudropdown2">
                                    <i class="zmdi zmdi-email zmdi-hc-fw"></i> 
                                    <span *ngIf="msgCounter"  class="notCount">{{msgCounter}}</span>
                                </a>
                                <mat-menu panelClass="menu_dropdown " #menudropdown2="matMenu">
                                    <div class="notifiDpMain notifiDp3">
                                        <div class="messHeader">
                                            Messages <a href="javascript:;" class="float-right" (click)="newMessagePopup()">New Message</a> 
                                        </div>
                                        <perfect-scrollbar #msgScroll style="max-width: 100%; max-height:280px;" [config]="{suppressScrollX:'false'}" (psYReachEnd)="getMessages()">
                                            <ul>
                                                <ng-container *ngIf="(messages && messages.length > 0);else no_msg_request">
                                                    <li *ngFor="let item of messages">
                                                        <a href="javascript:;">
                                                            <div class="notifiPic" [ngStyle]="{'background-image': 'url(' + _appService.getPicture(item.picture,'users',item.friend_id) + ')'}" ></div>
                                                            <h4 class="messHed">{{item.drafters_id}}  </h4>
                                                            <h5 class="sortMsg" [innerHTML]="item.chat_message | emojis"></h5>
                                                            <h5>{{item.created | date:'MMM d, y h:mm a'}}</h5>
                                                        </a>
                                                    </li>
                                                </ng-container>
                                                <ng-template #no_msg_request class="">
                                                    <li class="noMess">
                                                        <a href="javascript:;">
                                                            <h3>No messages</h3>
                                                        </a>
                                                    </li>
                                                </ng-template>
                                            </ul> 
                                        </perfect-scrollbar>
                                        <div class="notifiDpBtm">
                                            <a href="{{siteURL}}/user/messages">
                                                All Messages
                                            </a>
                                        </div>
                                    </div>
                                </mat-menu>
                            </li>
                            <li class="">
                                <a mat-button [matMenuTriggerFor]="menudropdown3">
                                    <i class="zmdi zmdi-notifications zmdi-hc-fw"></i>
                                    <span *ngIf="notifiCounter" class="notCount">{{notifiCounter}}</span>
                                </a>
                                <mat-menu panelClass="menu_dropdown " #menudropdown3="matMenu">
                                    <div class="notifiDpMain notifiDp3">
                                            <div class="messHeader">
                                                    Notifications 
                                                </div>
                                        <perfect-scrollbar #notiScroll style="max-width: 100%; max-height:280px;" [config]="{suppressScrollX:'false'}" (psYReachEnd)="getNotification()">
                                            <ul *ngIf="notificationData">
                                                <li *ngFor="let notiItem of notificationData">
                                                    <a href="{{notiItem.link}}">
                                                        <div class="notifiPic" [ngStyle]="{'background-image': 'url(' + notiItem.user_picture +')'}" ></div>
                                                        <h4>{{ notiItem.message }}</h4>
                                                        <h5>{{ notiItem.created | date: 'MMM d, h:mm a' }}</h5>
                                                    </a>
                                                </li>
                                            </ul>
                                        </perfect-scrollbar>
                                        <div class="notifiDpBtm">
                                            <a href="{{siteURL}}/user/notifications">
                                                See all notifications
                                            </a>
                                        </div>
                                    </div>
                                </mat-menu>
                            </li>
                        </ul>
                    </div> -->
                    <div class="addFundBtn dIb">
                        <div class="button-row">
                            <button mat-raised-button color="primary" class="addFundBtnD"
                                (click)="openDialog(1)">DEPOSIT</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--  mobile screen  -->
    <div *ngIf="isMobile">
        <app-active-drafts2 [(visible)]="adSpacer"></app-active-drafts2>
        <div class="myteam_responsivemenu" *ngIf="pageName.indexOf('draft') == -1">
            <div class="logoMobile">
                <a [href]="siteURL">
                    <img *ngIf="darkMode" src="assets/images/logo.png" alt="">
                    <img *ngIf="!darkMode" src="assets/images/logo.png" alt="">
            </a>
            </div>
            <div class="teammenu_icon" [matMenuTriggerFor]="menu"><i class="zmdi zmdi-menu"></i></div>
            <mat-menu #menu="matMenu">
                <div class="team_mobilemenu" id="mySidenav_team" *ngIf="userInfo">
                    <div class="teammenu_icon close"><i class="zmdi zmdi-close"></i></div>
                    <ul class="mobile_close_hhead">
                        <li>
                           <div class="dark-theme-toggle-mobile"> <label for="checkbox" class="label">
                              <input type="checkbox"  style="cursor: pointer;" class="checkbox" (click)="toggleDarkTheme()" id="checkbox">
                              <i class="fas fa-moon" *ngIf="this.darkMode"></i>
                              <i class='far fa-moon'  *ngIf="!this.darkMode"></i>
                            </label>
                        </div>
                        </li>
                        <li><a href="javascript:;" mat-menu-item [matMenuTriggerFor]="menudropdown1">
                                <i class="zmdi zmdi-accounts-alt zmdi-hc-fw"></i></a>
                            <mat-menu panelClass="menu_dropdown " #menudropdown1="matMenu">
                                <div class="notifiDpMain notifiDp3 notifiDp3Req">
                                    <div class="messHeader">
                                        Pending Requests
                                    </div>
                                    <perfect-scrollbar #friendRequestScroll style="max-width: 100%; max-height:280px;"
                                        [config]="{suppressScrollX:'false'}">
                                        <ul>
                                            <ng-container
                                                *ngIf="(friend_request && friend_request.length > 0);else no_request">
                                                <li *ngFor="let item of friend_request;let i = index">
                                                    <a href="javascript:;">
                                                        <div class="notifiPic"
                                                            [ngStyle]="{'background-image': 'url(' + item?.picture + ')'}">
                                                        </div>

                                                        <ng-container *ngIf="item.type == 'friends'">
                                                            <h4 class=""><span>{{item.drafters_id}} </span></h4>
                                                            <div class="pT5 requestBtn">
                                                                <button mat-raised-button color="primary"
                                                                    class="acceptBtn "
                                                                    (click)="acceptFriendRequest(item.friend_id,i,item)"><i
                                                                        class="zmdi zmdi-check"></i></button>

                                                                <button mat-raised-button color="primary"
                                                                    class="rejectBTn"
                                                                    (click)="rejectFriendRequest(item.friend_id,i)"><i
                                                                        class="zmdi zmdi-close"></i></button>

                                                            </div>
                                                        </ng-container>
                                                        <ng-container *ngIf="item.type == 'invitation'">
                                                            <h4 class="">
                                                                <a href="javascript:;"
                                                                    (click)="acceptInvitation(item)">{{item.drafters_id+' invited you to join the '+item.league_name}}
                                                                </a>
                                                            </h4>
                                                        </ng-container>
                                                    </a>
                                                </li>
                                            </ng-container>
                                            <ng-template #no_request>
                                                <li class="noMess">

                                                    <a href="javascript:;">
                                                        <h3>No New Request</h3>
                                                    </a>
                                                </li>

                                            </ng-template>
                                        </ul>
                                    </perfect-scrollbar>
                                </div>
                            </mat-menu>
                        </li>
                        <li><a href="javascript:;" mat-menu-item [matMenuTriggerFor]="menudropdown2">
                                <i class="zmdi zmdi-email zmdi-hc-fw"></i></a>
                            <mat-menu panelClass="menu_dropdown " #menudropdown2="matMenu">
                                <div class="notifiDpMain notifiDp3 notifiDp3Mess">
                                    <div class="messHeader">Messages</div>
                                    <perfect-scrollbar #msgScroll style="max-width: 100%; max-height:280px;"
                                        [config]="{suppressScrollX:'false'}" (psYReachEnd)="getMessages()">
                                        <ul>
                                            <ng-container *ngIf="(messages && messages.length > 0);else no_msg_request">
                                                <li *ngFor="let item of messages">
                                                    <a href="javascript:;" routerLink="/messages/{{item?.drafters_id}}">
                                                        <div class="notifiPic"
                                                            [ngStyle]="{'background-image': 'url(' + _appService.getPicture(item.picture,'users',item.friend_id) + ')'}">
                                                        </div>
                                                        <h4 class="">
                                                            <span>{{item.drafters_id}} </span>
                                                            <p [innerHTML]="unescapeString(item.chat_message) | emojis"></p>
                                                        </h4>
                                                        <h5>{{item.created | date:'MMM d, y h:mm a'}}</h5>
                                                    </a>
                                                </li>
                                            </ng-container>
                                            <ng-template #no_msg_request>
                                                <li class="noMess">

                                                    <a href="javascript:;">
                                                        <h3>No messages</h3>
                                                    </a>
                                                </li>
                                            </ng-template>
                                        </ul>
                                    </perfect-scrollbar>
                                    <div class="notifiDpBtm">
                                        <a routerLink="/messages">
                                            All Messages
                                        </a>
                                    </div>
                                </div>
                            </mat-menu>
                        </li>
                        <li><a href="javascript:;" mat-menu-item [matMenuTriggerFor]="menudropdown3">
                                <i class="zmdi zmdi-notifications zmdi-hc-fw"></i></a>
                            <mat-menu panelClass="menu_dropdown " #menudropdown3="matMenu">
                                <div class="notifiDpMain notifiDp3">
                                    <div class="messHeader">
                                        Notifications
                                    </div>
                                    <perfect-scrollbar #notiScroll style="max-width: 100%; max-height:280px;"
                                        [config]="{suppressScrollX:'false'}" (psYReachEnd)="getNotification()">
                                        <ul>
                                            <ng-container
                                                *ngIf="(notificationData && notificationData.length > 0);else no_notificationData">

                                                <li *ngFor="let notiItem of notificationData">
                                                    <a href="{{notiItem.link}}">
                                                        <div class="notifiPic"
                                                            [ngStyle]="{'background-image': 'url(' + notiItem.user_picture +')'}">
                                                        </div>
                                                        <h4>{{ notiItem.message }}</h4>
                                                        <h5>{{ notiItem.created * 1000 | date: 'MMM d, h:mm a' }}</h5>
                                                    </a>
                                                </li>
                                            </ng-container>
                                            <ng-template #no_notificationData>
                                                <li class="noMess">

                                                    <a href="javascript:;">
                                                        <h3>No Notification</h3>
                                                    </a>
                                                </li>
                                            </ng-template>
                                        </ul>

                                    </perfect-scrollbar>
                                    <div class="notifiDpBtm">
                                        <a href="{{siteURL}}/user/notifications">
                                            See all notifications
                                        </a>
                                    </div>
                                </div>
                            </mat-menu>
                        </li>
                    </ul>
                    <div class="team_mobileprofile">
                        <div class="userprofile"><img [src]="userInfo?.picture" alt="/"></div>
                        <a [href]="siteURL+'/'+user_name+'/profile'" class="username"> {{ drafters_id }} </a>
                    </div>
                    <div class="team_fundBlock">
                        <div class="fundRow">
                            <div class="fundDatablock fundLeft">Account Balance:</div>
                            <div class="fundDatablock fundRight">${{userInfo?.dollar_balance | number:'1.2-2' | Price}}</div>
                        </div>
                        <div class="fundRow">
                            <div class="fundDatablock fundLeft">In Play:</div>
                            <div class="fundDatablock fundRight">${{userInfo?.inplay_dollar_balance | number:'1.2-2' | Price}}
                            </div>
                        </div>
                        <div class="fundRow">
                            <div class="fundDatablock fundLeft">Currently Winning:</div>
                            <div class="fundDatablock fundRight">${{winAmt | number:'1.2-2' | Price}}</div>
                        </div>
                        <a href="javascript:;" class="btnAddFund" (click)="openDialog(1)">Add Funds</a>
                    </div>
                    <ul class="team_side_mainnav">
                        <li><a routerLink="/lobby"><i class="fa fa-trophy navIcon"></i><span>Find a
                                    Draft</span></a></li>
                        <li><a routerLink="/props"><i class="fas fa-check-circle"></i><span>Pick'em</span><span class="newBadge" *ngIf="this.props_launch_flag!=''">New</span></a></li>            
                        <li><a href="javascript:;" routerLink="/ownership/nfl"><i
                                    class="fas fa-user-circle"></i><span>Player Exposures</span></a></li>
                        <li><a [href]="siteURL+'/create-contest'"><i class="zmdi zmdi-gamepad"></i><span>Create a
                                    Game</span></a></li>
                        <li><a routerLink="/rankings"><i class="fas fa-sort-numeric-down"></i><span>Rankings</span></a>
                        </li>
                        <li><a [href]="siteURL+'/'+drafters_id+'/friends'"><i
                                    class="zmdi zmdi-accounts navIcon"></i><span>Find Friends</span></a></li>
                        <!-- <li><a href="javascript:;" (click)="openDialog()"><i class="fas fa-dollar-sign navIcon"></i><span>Cashier </span></a></li> -->
                        <li><a  routerLink="/messages"><i
                                    class="zmdi zmdi-comments navIcon"></i><span>Messages</span></a></li>
                        <li><a href="{{siteURL+'/rules'}}"><i
                            class="fas fa-gavel"></i><span>Rules and Scoring</span></a></li>
                        <li><a href="{{siteURL+'/pages/privacypolicy'}}"><i
                            class="fas fa-user-shield"></i><span>Privacy Policy</span></a></li>
                        <li><a href="{{siteURL+'/pages/termsofuse'}}"><i
                            class="fas fa-info-circle"></i><span>Terms & Conditions</span></a></li>
                        <li><a href="javascript:;" (click)="openFAQ()"><i
                                    class="zmdi zmdi-help"></i><span>Help</span></a></li>
                        <li><a routerLink="/responsible"><i class="fas fa-hands-helping"></i><span>Responsible
                                    Gaming</span></a></li>
                        <li>
                            <!-- <a [href]="siteURL+'/user/refer-friend'"> -->
                            <a routerLink ="/user/refer-friend" [ngClass]="{active:(pageName.indexOf('refer-friend') > -1)}">
                                <i class="fa fa-sitemap navIcon"></i><span>Refer a
                                    Friend</span></a></li>
                        <li><a [href]="siteURL+'/setting'"><i class="zmdi zmdi-settings"></i><span>Setting</span></a>
                        </li>
                        <li><a href="javascript:;" (click)="onLogout()"><i class="fas fa-sign-out-alt"></i><span>Sign
                                    Out</span></a></li>
                    </ul>
                    <div class="team_search_bar">
                        <!-- <form>
                        <div class="form-group">
                            <i class="zmdi zmdi-search"></i>
                            <input type="text" placeholder="Search.." class="form-control" name="search">
                        </div>
                    </form> -->
                    </div>
                </div>
            </mat-menu>
            </div>
        <!-- Footer Tabs -->
        <footer class="myteam_cat_menu" *ngIf="pageName.indexOf('draft') == -1 && pageName.indexOf('messages') == -1 && pageName.indexOf('props') == -1 && showHeader">
            <ul class="myteam_indiv">
                <li [ngClass]="{active:pageName.indexOf('lobby') > -1}"><a routerLink="/lobby"><i class="fa fa-trophy"
                            aria-hidden="true"></i><span>Lobby</span></a></li>
                <li [ngClass]="{active:pageName.indexOf('myteams') > -1}"><a routerLink="/myteams"><i class="fa fa-star"
                            aria-hidden="true"></i><span>My Team</span></a></li>
                <li [ngClass]="{active:pageName.indexOf('rankings') > -1}"><a routerLink="/rankings">
                        <i class="fas fa-sort-numeric-down" aria-hidden="true"></i><span>Rankings</span></a></li>
                <li [ngClass]="{active:pageName.indexOf('news') > -1}"><a routerLink="/news"><i class="fa fa-newspaper"
                            aria-hidden="true"></i><span>News</span></a></li>
                <li><a href="javascript:;" (click)="openDialog(1)"><i class="fas fa-dollar-sign"
                            aria-hidden="true"></i><span>Deposit</span></a></li>
            </ul>
        </footer>
    </div>
</header>
<div class="extraSpacer" *ngIf="adSpacer && isMobile && pageName.indexOf('draft') == -1"></div>
<div class="extraSpacer2" *ngIf="isMobile && pageName.indexOf('draft') == -1"></div>